
import HomeSection from "../components/sections/HomeSection";
import SponsorSection from "../components/sections/SponsorSection";
import SpecsSection from "../components/sections/SpecsSection";
import ArSection from "../components/sections/ArSection";
import HowItWorksSection from "../components/sections/HowItWorksSection";
import ProductsSection from "../components/sections/ProductsSection";
import OurTrustedPartner from "../components/sections/trustedBy";
import DownloadSection from "../components/sections/DownloadSection";
import VideoPlayer from "../components/sections/video";
import AppReviews from"../components/sections/appReviews";
export default function HomePage() {
  return (
    <>

      <main className="main">
        <HomeSection />
        <SponsorSection />
        <SpecsSection />
        <ArSection />
        {/* <HowItWorksSection /> */}
        <ProductsSection />
        <VideoPlayer/>
        {/* <FaqSection /> */}
        <AppReviews/>
        <DownloadSection />
        <OurTrustedPartner/>
      </main>

    </>
  );
}
